import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createRegion = async (payload: Record<string, unknown>) => {
	const response = await cmsClient.post(
		"/homepage/admin/store/region/",
		payload
	);

	return response.data;
};

const useCreateRegion = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Region created" />, {
			hideProgressBar: true
		});
	};

	const onError = (error: unknown) => {
		const detail = (error as any)?.response?.data;
		const message =
			detail?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : null) ??
			"Something went wrong, try again";
		const safeMessage =
			message.length > 200 ? message.slice(0, 200) + "..." : message;

		toast.error(<CustomToast type="Error" message={safeMessage} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-regions"]);
	};

	return useMutation(createRegion, { onSuccess, onError, onSettled });
};

export default useCreateRegion;
